// extracted by mini-css-extract-plugin
export default {"logoContainer":"invitation_logoContainer__VAmT7","logo":"invitation_logo__xOCWx","bg":"invitation_bg__kzSNg"};